<script lang="ts">
	// The «سطور | كروت» switch on a restaurant's page (UC-31), #959's option A:
	// the menu as rows or as cards. The worker draws it only while the shop's
	// menu holds a photo, and picks the first view: cards when more than half
	// of the shop's items have a photo, rows otherwise. The diner's choice
	// holds for this page only and is kept nowhere.
	//
	// It shows in one of two places by width (#1020): the back row under
	// 640 px, the pinned category row from 640 px. Its parent draws the place
	// and hides it on the other side; both copies share one view
	// (view.svelte.ts), which the menu's data-view follows, so a tap on
	// either presses both and the menu keeps its place.

	import Segmented from '../components/Segmented.svelte';
	import { restaurant } from './copy';
	import { choose, follow, shown, type View } from './view.svelte';

	interface Props {
		first: View;
		/** Where this copy sits: the back row, or the pinned bar's category row. */
		place?: 'back' | 'bar';
	}

	let { first, place = 'back' }: Props = $props();

	const value = $derived(shown(first));
	const id = $derived(place === 'bar' ? 'catalogue-view-bar' : 'catalogue-view');

	$effect(() => {
		follow();
	});
</script>

<Segmented
	label={restaurant.view}
	testId={id}
	{value}
	options={[
		{ value: 'list', label: restaurant.viewList, testId: `${id}-list` },
		{ value: 'cards', label: restaurant.viewCards, testId: `${id}-cards` },
	]}
	onChange={(v) => choose(v === 'cards' ? 'cards' : 'list')}
/>
